/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";
import { saveAs } from 'file-saver';

/** Common Components */
import CardSection from "../../../../components/ui/card/CardSection";
import formatDate from "../../../../components/finalMolGrid/libs/formatDate";
import MolGrid, { Column } from '@moltech/molui/molgrid';
import ToastService from "../../../../services/toastService/ToastService";
import { ServiceLocationContext } from "../../../../utils/context/ServiceLocationContext";

/**Wrapped Component */
import Financial from "../../Financial";

/** CSS Files */
import "../../Financial.scss";

/**API calling */
import { useClientUpdateOnHoldMutation, useExportClientsOnHoldMutation } from "../../../../app/services/financialsAPI";
import { useGetMolGridDataMutation } from "../../../../app/services/commonAPI";

/** utilities */
import { customRowsPerPageDropdown, getDropdownValue } from "../../../../components/finalForms/libs/data/dropdownUtilities";

const ClientsOnHold = () => {

  const gridRef = useRef();

  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);
  const currentDate = formatDate(new Date(), "MM-DD-YYYY");
  const [isDisable, setIsDisable] = useState(true);

  const [exportClientsOnHold, {
    isLoading: isAllExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportClientsOnHoldMutation();

  const [clientUpdateOnHold, {
    isLoading: isclientUpdateLoading,
    isSuccess: isclientUpdateSuccess,
    data: clientUpdateData,
  },] = useClientUpdateOnHoldMutation();

  useEffect(() => {
    if (isclientUpdateSuccess && clientUpdateData) {
      ToastService.success(clientUpdateData.errorMessage);
    }
  }, [isclientUpdateLoading, isclientUpdateSuccess, clientUpdateData])

  // Export All Details response handling
  useEffect(() => {
    if (!isAllExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Clients On Hold ${currentDate}.xlsx`);
    }
  }, [isAllExporting, isAllExported, exportAllData]);

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }, [locationkey, isclientUpdateLoading]);

  const beforeMolGridLoad = (reqPrm) => {
    const req = {
      pagination: {
        pageNumber: (reqPrm.first / reqPrm.rows) + 1,
        pageSize: reqPrm.rows
      },
      sortField: reqPrm.sortField,
      sortOrder: reqPrm.sortOrder,
      plServiceLocationKey: locationkey,
      groupBy: reqPrm.groupBy ? reqPrm.groupBy : '',
    };
    return req;
  }

  const afterMolGridLoad = (data) => {
    setIsDisable(false);
    return {
      data: data.dataSource,
      count: data.totalRecord
    };
  }

  const UpdateClientOnHold = (rowData) => {
    if (rowData) {
      const req = {
        plClientKey: rowData.lClientKey,
        pbNeverHold: !rowData?.bNeverHold,
      }
      clientUpdateOnHold(req);
    }
  }
  const rowClass = (rowData) => {
    return {
      'green-color-row': rowData.bNeverHold === true,
      'black-color-row': rowData.bNeverHold === false,
    };
  };

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: row?.bNeverHold ? "Start Hold Again" : "Never Hold",
        // icon: 'pi pi-plus',
        command: () => UpdateClientOnHold(row)
      },

    ];
  }

  const handleDownloadClick = () => {
    const request = {
      plClientKey: null,
      plDepartmentKey: null,
      plServiceLocationKey: locationkey,
      pbCheckingBypass: null,
      plSalesRepKey: null
    }
    exportClientsOnHold(request);
  }
  return (
    <div className="supplier-po-table head-center clients-on-hold-list small-card-btn-sec">
      <CardSection
        cardTitle={`Clients On Hold`}
        isButtonVisible={true}
        titleButtonClick={handleDownloadClick}
        rightButton={true}
        buttonClassName={'blue-btn mb-1'}
        titleText={'Export'}
        isIcon={true}
        iconClass="file-icons:microsoft-excel"
        isButtonDisable={isDisable}
        isButtonLoading={isAllExporting}
      >
        <div className="scrollable-grid">
          <MolGrid ref={gridRef} url="/Financials/GetAllClientsOnHold" client={useGetMolGridDataMutation}
            beforeLoad={beforeMolGridLoad}
            afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}

            scrollable
            scrollHeight="flex"
            filterDisplay="row"

            sortMode="single"
            showGridlines
            resizableColumns

            paginator
            rowsPerPageOptions={[10, 25, 50, 100]}
            rows={99999}
            paginatorTemplate={{
              layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              RowsPerPageDropdown: (options) => {
                return customRowsPerPageDropdown(options, options?.value)
              }
            }}
            ctxMenuItems={getCtxMenuItems}
            rowClassName={rowClass}
          >
            <Column field="sClientName1" header="Client" grouping sortable />
            <Column field="repName" header="Sales Rep" grouping sortable />
            <Column field="minAging" header="Min Aging > = 120" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="maxAging" header="Max Aging" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="invoiceCount" header="Invoices > = 120" bodyStyle={{ textAlign: "center" }} grouping sortable />
          </MolGrid>
        </div>
      </CardSection>
    </div>

  );
};
export default Financial(ClientsOnHold);
